import { FC } from "react";
import { Helmet } from "react-helmet-async";

export interface PageContactProps {
  className?: string;
}

const PageContact: FC<PageContactProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <Helmet>
        {/* TITLE */}
        <title>
          Contact Devi Plastic | Sink Coupling Manufacturer in Ahmedabad,
          Gujarat
        </title>

        {/* META DESCRIPTION */}
        <meta
          name="description"
          content="Contact Devi Plastic – trusted manufacturer of sink couplings and plastic drainage fittings in Ahmedabad, Gujarat. Call +91 99248 23363 or visit our factory in Odhav."
        />

        {/* KEYWORDS */}
        <meta
          name="keywords"
          content="contact Devi Plastic, sink coupling manufacturer Ahmedabad, plastic drainage fittings Gujarat, Devi Plastic contact number, sink coupling factory Ahmedabad, plastic manufacturer Odhav Ahmedabad"
        />

        {/* CANONICAL */}
        <link rel="canonical" href="https://www.deviplastic.in/contact" />

        {/* OPEN GRAPH */}
        <meta
          property="og:title"
          content="Contact Devi Plastic | Sink Coupling Manufacturer"
        />
        <meta
          property="og:description"
          content="Get in touch with Devi Plastic – premium sink coupling & drainage fittings manufacturer from Ahmedabad, Gujarat."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deviplastic.in/contact" />
        <meta
          property="og:image"
          content="https://www.deviplastic.in/og-contact.jpg"
        />

        {/* TWITTER */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Devi Plastic | Ahmedabad Sink Coupling Manufacturer"
        />
        <meta
          name="twitter:description"
          content="Call or visit Devi Plastic for premium sink couplings and drainage fittings manufactured in Gujarat."
        />

        {/* STRUCTURED DATA – LOCAL BUSINESS / MANUFACTURER */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Devi Plastic",
            url: "https://www.deviplastic.in/contact",
            logo: "https://www.deviplastic.in/logo.png",
            image: "https://www.deviplastic.in/og-contact.jpg",
            description:
              "Devi Plastic is a trusted manufacturer of sink couplings and plastic drainage fittings based in Ahmedabad, Gujarat.",
            telephone: "+91-9924823363",
            priceRange: "₹₹",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "111/A, Vijay Industrial Estate, Near Bhikshuk Gruh, Odhav",
              addressLocality: "Ahmedabad",
              addressRegion: "Gujarat",
              postalCode: "382415",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "23.01718",
              longitude: "72.54447",
            },
            areaServed: {
              "@type": "Country",
              name: "India",
            },
            sameAs: ["https://maps.google.com/?q=DEVI+PLASTIC+Odhav+Ahmedabad"],
          })}
        </script>
      </Helmet>

      <div className="container max-w-7xl mx-auto py-20">
        {/* Page Title */}
        <h2 className="mb-16 text-center text-3xl md:text-5xl font-semibold text-neutral-900 dark:text-neutral-100">
          Contact Us
        </h2>

        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="uppercase font-semibold text-sm tracking-wider">
                📍 Address
              </h3>
              <p className="mt-2 text-neutral-600 dark:text-neutral-400">
                111/A, VIJAY IND. ESTATE, NEAR, <br />
                BHIKSHUK GRUH, ODHAV, AHMEDABAD, 382415, Gujarat.
                <a
                  href="https://maps.google.com/?q=DEVI+PLASTIC+Odhav+Ahmedabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
    inline-flex items-center gap-2 mt-3 px-5 py-2.5
    rounded-full font-medium text-white
    bg-gradient-to-r from-green-500 to-emerald-600
    shadow-lg shadow-green-500/30
    hover:from-green-600 hover:to-emerald-700
    hover:shadow-xl hover:shadow-green-500/40
    transition-all duration-300 ease-out
    active:scale-95
    focus:outline-none focus:ring-2 focus:ring-green-400
  "
                >
                  📍 View on Google Maps
                </a>
              </p>
            </div>

            <div>
              <h3 className="uppercase font-semibold text-sm tracking-wider">
                📞 Phone
              </h3>
              <p className="mt-2 text-neutral-600 dark:text-neutral-400">
                <a href="tel:9924823363" className="hover:underline">
                  +91 99248 23363
                </a>
              </p>
            </div>
          </div>

          {/* Google Map */}
          <div className="w-full h-[350px] rounded-2xl overflow-hidden shadow-lg">
            <iframe
              title="Devi Plastic Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117509.74431537521!2d72.54447476758688!3d23.01718026048262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e874765367f3f%3A0x43387030b059f707!2sDEVI%20PLASTIC!5e0!3m2!1sen!2sin!4v1766912757466!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContact;
